"use strict";

//если селектор не задан, возвращает true если кол-во элементов больше нуля
//если задан, возвращает true, если есть хотя бы один элемент удовлетворяющий селектору
Array.prototype.any = function (selector) {
  if (selector === undefined) {
    return this.length > 0;
  }
  for (var i = 0; i < this.length; i++) {
    if (selector(this[i])) return true;
  }
  return false;
};

//возвращает первый элемент массива, для которого истинен селектор, либо null
Array.prototype.firstOrDefault = function (selector) {
  for (var i = 0; i < this.length; i++) {
    if (selector(this[i])) return this[i];
  }
  return null;
};

//возвращает индекс первого элемента, для которого истинен селектор, либо null
Array.prototype.indexOfWhere = function (selector) {
  for (var i = 0; i < this.length; i++) {
    if (selector(this[i])) return i;
  }
  return -1;
};

//возвращает индекс первого эламента, который равен аргументу, для которого истинен селектор, либо null
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function (elt) {
    var len = this.length >>> 0;
    var from = Number(arguments[1]) || 0;
    from = from < 0 ? Math.ceil(from) : Math.floor(from);
    if (from < 0) from += len;
    for (; from < len; from++) {
      if (from in this && this[from] === elt) return from;
    }
    return -1;
  };
}
Array.prototype.contains = function (object) {
  return this.indexOf(object) == -1 ? false : true;
};

//возвращает новый массив элементы которого удовлетворяют условию селектора
Array.prototype.where = function (selector) {
  var output = [];
  for (var i = 0; i < this.length; i++) {
    if (selector(this[i])) output.push(this[i]);
  }
  return output;
};

//удаляет первый элемент из массива
Array.prototype.remove = function (objectToRemove) {
  for (var i = 0; i < this.length; i++) {
    if (this[i] == objectToRemove) {
      this.splice(i, 1);
      return;
    }
  }
};

//удаляет первый элемент, который удовлетворяет условию селектора
Array.prototype.removeWhere = function (selector) {
  for (var i = 0; i < this.length; i++) {
    if (selector(this[i])) {
      this.remove(this[i]);
      return;
    }
  }
};

//выполняет переданную функцию для кадого элемента массива
//если breakable = true, то при возвращении любого значения функцией, foreach прервется
//если breackValue не undefined, то цикл прервется в том случае если функция вернет breackValue
Array.prototype.foreach = function (action, breakable, breakValue) {
  for (var i = 0; i < this.length; i++) {
    var result = action(this[i]);
    if (breakable === true) {
      if (breakValue !== undefined) {
        if (result == breakValue) return;
      } else {
        if (result !== undefined) return;
      }
    }
  }
};

//возвращает новый массив элементы которого удовлетворяют условию селектора
Array.prototype.select = function (selector) {
  var output = [];
  for (var i = 0; i < this.length; i++) {
    output.push(selector(this[i]));
  }
  return output;
};
Array.prototype.sum = function (selector) {
  var sum = 0;
  for (var i = 0; i < this.length; i++) {
    sum += selector();
  }
  return sum;
};